<div [@pageAnimations]="isHovered ? 'hovered' : 'basic'" class="elements__container">
  @if (isHovered) {
    <ng-content></ng-content>
  }
</div>
<div class="trigger__container" (mouseover)="onOver()">
  <ng-content select="[trigger]"></ng-content>
</div>
